import SiteHeader from "views/components/SiteHeader";
import { SiteFooter } from "views/components/SiteFooter";

export const Layout = (props) => {
    return (
        <div
            vaul-drawer-wrapper=""
            style={{
                transformOrigin: "center top",
                transitionProperty: "transform, border-radius",
                transitionDuration: "0.5s",
                transitionTimingFunction: "cubic-bezier(0.32, 0.72, 0, 1)",
            }}
        >
            <div className="relative flex min-h-svh flex-col bg-background">
                <div
                    data-wrapper=""
                    className="border-grid flex flex-1 flex-col"
                >
                    <SiteHeader />
                    <main className="flex flex-1 flex-col">
                        {props.children}
                    </main>
                    <SiteFooter />
                </div>
            </div>
        </div>
    );
};
